export default "__VITE_ASSET__BWlkXEjR__";